import React, { useState, useCallback } from 'react'
import { CustomEmbed } from '~/reactapp/story/ans/types'
import { IEllipsisReduxStore } from '~/redux/types'
import { CustomEmbedBlock } from '~/reactapp/DraftEditor/blockRenderers/customEmbedRenderer'

interface Props {
  embed: CustomEmbed
  setEmbed: (value: { embed: CustomEmbed }) => void
  customEmbedTypes: IEllipsisReduxStore['settings']['customEmbed']
}

export default function CustomEmbedBlockWrapper(props: Props) {
  const { embed, setEmbed, customEmbedTypes } = props

  const [isEditing, setIsEditing] = useState(false)

  const submitValues = useCallback(
    (_, __, data: unknown) => {
      setEmbed({ embed: data as CustomEmbed })
      setIsEditing(false)
    },
    [setEmbed, setIsEditing]
  )

  return (
    <CustomEmbedBlock
      ans={embed}
      customEmbedTypes={customEmbedTypes}
      isEditing={isEditing}
      setIsEditing={setIsEditing}
      submitValues={submitValues}
    />
  )
}
